<template>
	<v-card elevation="0" :key="renderizar" color="background">
		<v-card-title class="pb-0 pt-0 texto--text"><strong>Filtrar por:</strong></v-card-title>
		<v-list class="pt-0" expand :width="largura" color="background">
			<template v-for="(filtro, i) in filtros">
				<v-list-group :key="i" v-if="filtro.nome && filtro.itens && filtro.itens.length > 0" :value="true" color="texto">
					<template slot="activator">
						<v-list-item-content>
							<v-list-item-title class="filtrosTitulo">
								<strong>{{ filtro.nome }}</strong>
							</v-list-item-title>
						</v-list-item-content>
					</template>
					<template v-for="(item, j) in filtro.itens">
						<v-list-item :key="j" v-if="j < limites[i]">
							<v-list-item-action>
								<v-checkbox class="checkbox" v-model="filtrosSelecionados[i]" :value="item.nome"
									:label="item.nome" :multiple="false"
									@click="filtrar(i, filtrosSelecionados[i], filtro)" />
							</v-list-item-action>
						</v-list-item>
					</template>
					<v-btn color="primary" text @click="mostrar(i)" v-if="filtro.itens && filtro.itens.length > 3">
						{{ limites[i] == filtro.itens.length ? 'mostrar menos' : 'mostrar mais' }}
					</v-btn>
				</v-list-group>
			</template>
		</v-list>
		<v-card-actions class="pb-5" v-if="mobile">
			<v-spacer />
			<v-btn color="primary" text @click="limparFiltroMobile">limpar</v-btn>
			<v-spacer />
			<v-btn color="primary" @click="filtrarMobile">filtrar</v-btn>
			<v-spacer />
		</v-card-actions>
	</v-card>
</template>

<script>
export default {
	props: {
		marcas: {},
		grupos: {},
		subgrupos: {},
		skus: {},
		mobile: Boolean,
	},
	data() {
		return {
			filtrosSelecionados: [],
			limites: [3, 3, 3, 3, 3, 3, 3],
			expandir: [true, true, true],
			renderizar: false,
		}
	},
	computed: {
		filtros() {
			let filtros = []
			filtros.push(this.marcas)
			filtros.push(this.grupos)
			filtros.push(this.subgrupos)

			if (this.skus && this.skus.length > 0) {
				this.skus.map((sku) => { filtros.push({ nome: sku.nome, itens: sku.itens }) })
			}

			return filtros
		},
		largura() {
			if (this.mobile) return '100%'
			else return '180'
		}
	},
	methods: {
		filtrar(seq, nome, filtro) {
			if (!this.mobile) {
				if (seq == 0) {
					this.filtrarMarca(nome)
				} else if (seq == 1) {
					this.filtrarGrupo(nome)
				} else if (seq == 2) {
					this.filtrarSubgrupo(nome)
				} else if (seq >= 3 && filtro.nome == 'Cores') {
					this.filtrarCor(nome)
				} else if (seq >= 3 && filtro.nome == 'Tamanhos') {
					this.filtrarTamanho(nome)
				} else if (filtro.nome == 'Voltagens') {
					this.filtrarVoltagem(nome)
				} else if (seq >= 3 && filtro.nome == 'Sabores') {
					this.filtrarSabor(nome)
				}
			}
		},
		filtrarMobile() {
			if (this.mobile) {
				this.$router.replace(
					{
						query: Object.assign(
							{ ...this.$route.query },
							{
								marca: this.filtrosSelecionados[0] ? this.filtrosSelecionados[0] : '',
								grupo: this.filtrosSelecionados[1] ? this.filtrosSelecionados[1] : '',
								subgrupo: this.filtrosSelecionados[2] ? this.filtrosSelecionados[2] : '',
								cor: this.filtrosSelecionados[3] ? this.filtrosSelecionados[3] : '',
								tamanho: this.filtrosSelecionados[4] ? this.filtrosSelecionados[4] : '',
								voltagem: this.filtrosSelecionados[5] ? this.filtrosSelecionados[5] : '',
								sabor: this.filtrosSelecionados[6] ? this.filtrosSelecionados[6] : '',
								pagina: 1,
							}
						),
					},
					() => { }
				)
			}
		},
		limparFiltroMobile() {
			this.filtrosSelecionados = []
			this.filtrarMobile()
		},
		filtrarMarca(nome) {
			this.$router.replace(
				{
					query: Object.assign(
						{ ...this.$route.query },
						{
							marca: nome,
							pagina: 1,
						}
					),
				},
				() => { }
			)
		},
		filtrarGrupo(nome) {
			this.$router.replace(
				{
					query: Object.assign(
						{ ...this.$route.query },
						{
							grupo: nome,
							pagina: 1,
						}
					),
				},
				() => { }
			)
		},
		filtrarSubgrupo(nome) {
			this.$router.replace(
				{
					query: Object.assign(
						{ ...this.$route.query },
						{
							subgrupo: nome,
							pagina: 1,
						}
					),
				},
				() => { }
			)
		},
		filtrarCor(nome) {
			this.$router.replace(
				{
					query: Object.assign(
						{ ...this.$route.query },
						{
							cor: nome,
							pagina: 1,
						}
					),
				},
				() => { }
			)
		},
		filtrarTamanho(nome) {
			this.$router.replace(
				{
					query: Object.assign(
						{ ...this.$route.query },
						{
							tamanho: nome,
							pagina: 1,
						}
					),
				},
				() => { }
			)
		},
		filtrarVoltagem(nome) {
			this.$router.replace(
				{
					query: Object.assign(
						{ ...this.$route.query },
						{
							voltagem: nome,
							pagina: 1,
						}
					),
				},
				() => { }
			)
		},
		filtrarSabor(nome) {
			this.$router.replace(
				{
					query: Object.assign(
						{ ...this.$route.query },
						{
							sabor: nome,
							pagina: 1,
						}
					),
				},
				() => { }
			)
		},
		mostrar(i) {
			this.limites[i] = this.limites[i] == this.filtros[i].itens.length ? 3 : this.filtros[i].itens.length

			this.renderizar = !this.renderizar
		},
	},
	beforeMount() {
		this.filtrosSelecionados[0] = this.$route.query.marca ? this.$route.query.marca : ''
		this.filtrosSelecionados[1] = this.$route.query.grupo ? this.$route.query.grupo : ''
		this.filtrosSelecionados[2] = this.$route.query.subgrupo ? this.$route.query.subgrupo : ''
		this.filtrosSelecionados[3] = this.$route.query.cor ? this.$route.query.cor : ''
		this.filtrosSelecionados[4] = this.$route.query.tamanho ? this.$route.query.tamanho : ''
		this.filtrosSelecionados[5] = this.$route.query.voltagem ? this.$route.query.voltagem : ''
		this.filtrosSelecionados[6] = this.$route.query.sabor ? this.$route.query.sabor : ''
	},
}
</script>

<style>
.filtrosTitulo {
	font-size: 1.2rem;
}

.v-list-group .v-list-group__header .v-list-item__icon.v-list-group__header__append-icon {
	min-width: 0px;
}

.v-label.theme--light {
	color: var(--v-texto-base);
}

.checkbox .theme--light.v-icon {
	color: var(--v-texto-base);
}
</style>
